import React from "react";

import {
  TextInput,
  BooleanInput,
  FormDataConsumer,
  Loading,
  useQueryWithStore,
  useQuery,
  useDataProvider,
  useAuthenticated,
  SelectInput,
} from "react-admin";

import { Form } from "react-final-form";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/styles";

import { Error } from "../Error";
const useStyle = makeStyles({
  button: {
    color: "#fff",
  },
  loader: {
    color: "#fff",
  },
});

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const TimeSlots = [
  { id: "0", slot: "00:00" },
  { id: "1", slot: "01:00" },
  { id: "2", slot: "02:00" },
  { id: "3", slot: "03:00" },
  { id: "4", slot: "04:00" },
  { id: "5", slot: "05:00" },
  { id: "6", slot: "06:00" },
  { id: "7", slot: "07:00" },
  { id: "8", slot: "08:00" },
  { id: "9", slot: "09:00" },
  { id: "10", slot: "10:00" },
  { id: "11", slot: "11:00" },
  { id: "12", slot: "12:00" },
  { id: "13", slot: "13:00" },
  { id: "14", slot: "14:00" },
  { id: "15", slot: "15:00" },
  { id: "16", slot: "16:00" },
  { id: "17", slot: "17:00" },
  { id: "18", slot: "18:00" },
  { id: "19", slot: "19:00" },
  { id: "20", slot: "20:00" },
  { id: "21", slot: "21:00" },
  { id: "22", slot: "22:00" },
  { id: "23", slot: "23:00" },
  { id: "24", slot: "24:00" },
];
const AvailabilityForm = ({ aid }) => {
  useAuthenticated();
  const { loaded, data, error } = useQueryWithStore({
    type: "getOne",
    resource: "Availability",
    payload: { id: aid },
  });

 
  const classes = useStyle();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = React.useState(false);
  const [notification, setNotification] = React.useState({
    open: false,
    type: "info",
    message: "",
  });

  const OnSubmit = async (values) => {
    setLoading(true);
    let submitflag = true;

    if (submitflag) {
      dataProvider
        .update("Availability", {
          id: aid,
          data: values,
        })
        .then(
          (success) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "success",
              message: "Availability Updated Successfully",
            });
          },
          (error) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "error",
              message: "Something went wrong. Please retry",
            });
          }
        );
    }
  };

  const validate = (values) => {
    const errors = {};
    if (
      !values.mondayStartTime.includes(":00") &&
      !values.mondayStartTime.includes(":30")
    ) {
      errors.mondayStartTime = "Invalid Time";
    }
    if (
      !values.mondayStopTime.includes(":00") &&
      !values.mondayStopTime.includes(":30")
    ) {
      errors.mondayStopTime = "Invalid Time";
    }
    if (
      !values.tuesdayStartTime.includes(":00") &&
      !values.tuesdayStartTime.includes(":30")
    ) {
      errors.tuesdayStartTime = "Invalid Time";
    }
    if (
      !values.tuesdayStopTime.includes(":00") &&
      !values.tuesdayStopTime.includes(":30")
    ) {
      errors.tuesdayStopTime = "Invalid Time";
    }
    if (
      !values.wednesdayStartTime.includes(":00") &&
      !values.wednesdayStartTime.includes(":30")
    ) {
      errors.wednesdayStartTime = "Invalid Time";
    }
    if (
      !values.wednesdayStopTime.includes(":00") &&
      !values.wednesdayStopTime.includes(":30")
    ) {
      errors.wednesdayStopTime = "Invalid Time";
    }
    if (
      !values.thursdayStartTime.includes(":00") &&
      !values.thursdayStartTime.includes(":30")
    ) {
      errors.thursdayStartTime = "Invalid Time";
    }
    if (
      !values.thursdayStopTime.includes(":00") &&
      !values.thursdayStopTime.includes(":30")
    ) {
      errors.thursdayStopTime = "Invalid Time";
    }
    if (
      !values.fridayStartTime.includes(":00") &&
      !values.fridayStartTime.includes(":30")
    ) {
      errors.fridayStartTime = "Invalid Time";
    }
    if (
      !values.fridayStopTime.includes(":00") &&
      !values.fridayStopTime.includes(":30")
    ) {
      errors.fridayStopTime = "Invalid Time";
    }
    if (
      !values.saturdayStartTime.includes(":00") &&
      !values.saturdayStartTime.includes(":30")
    ) {
      errors.saturdayStartTime = "Invalid Time";
    }
    if (
      !values.saturdayStopTime.includes(":00") &&
      !values.saturdayStopTime.includes(":30")
    ) {
      errors.saturdayStopTime = "Invalid Time";
    }
    if (
      !values.sundayStartTime.includes(":00") &&
      !values.sundayStartTime.includes(":30")
    ) {
      errors.sundayStartTime = "Invalid Time";
    }
    if (
      !values.sundayStopTime.includes(":00") &&
      !values.sundayStopTime.includes(":30")
    ) {
      errors.sundayStopTime = "Invalid Time";
    }

    if (values.vacationMode) {
      if (!values.hasOwnProperty("vacationStartDate"))
        errors.vacationStartDate = "Required";
      if (!values.hasOwnProperty("vacationEndDate"))
        errors.vacationEndDate = "Required";
    }

    if (values.vacationMode) {
   
      if (values.vacationStartDate > values.vacationEndDate)
        errors.vacationStartDate = "Invalid Date";
      // errors.vacationEndDate = "Required";

      // if (values.vacationEndDate.length === 0)
      //   errors.vacationEndDate = "Required";
    }
    return errors;
  };

  const ui = !loaded ? (
    <Loading />
  ) : (
    <Form
      onSubmit={OnSubmit}
      initialValues={data}
      validate={validate}
      render={({ handleSubmit, reset, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit}>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item>
              <Typography variant="body1">
                Share your Availability, your mentees will connect with you
                during the same period
              </Typography>
            </Grid>
            <Grid item>
              <Grid container direction="row" spacing={2}>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Monday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          <SelectInput
                            source="mondayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="mondayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="mondayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Tuesday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          {/* <TextInput
                            label="From"
                            type="time"
                            source="tuesdayStartTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="tuesdayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="tuesdayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="tuesdayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Wednesday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          {/* <TextInput
                            label="From"
                            type="time"
                            source="wednesdayStartTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="wednesdayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="wednesdayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="wednesdayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Thursday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          {/* <TextInput
                            label="From"
                            type="time"
                            source="thursdayStartTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="thursdayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="thursdayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="thursdayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Friday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          {/* <TextInput
                            label="From"
                            type="time"
                            source="fridayStartTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="fridayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="fridayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="fridayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Saturday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          {/* <TextInput
                            label="From"
                            type="time"
                            source="saturdayStartTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="saturdayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="saturdayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="saturdayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="column" style={{ margin: "auto" }}>
                    <Grid item>
                      <Typography variant="h6">Sunday</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" spacing={1}>
                        <Grid item>
                          {/* <TextInput
                            label="From"
                            type="time"
                            source="sundayStartTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="sundayStartTime"
                            choices={TimeSlots}
                            label="From"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                        <Grid item>
                          {/* <TextInput
                            label="To"
                            type="time"
                            source="sundayStopTime"
                            variant="standard"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 1800,
                            }}
                          /> */}
                          <SelectInput
                            source="sundayStopTime"
                            choices={TimeSlots}
                            label="To"
                            optionText="slot"
                            optionValue="slot"
                            style={{
                              minWidth: "100px",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginTop: "2vh" }}>
              <BooleanInput source="vacationMode" label="Vacation Mode" />
            </Grid>
            <Grid container direction="row" spacing={2}>
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  return !formData.vacationMode ? null : (
                    <React.Fragment>
                      <Grid item>
                        <TextInput
                          label="From"
                          type="date"
                          source="vacationStartDate"
                          variant="standard"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <TextInput
                          label="To"
                          type="date"
                          source="vacationEndDate"
                          variant="standard"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </React.Fragment>
                  );
                }}
              </FormDataConsumer>
            </Grid>
            <Grid item style={{ marginTop: 16 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                className={classes.button}
              >
                {!loading ? "Submit" : <CircularProgress />}
              </Button>
            </Grid>
          </Grid>
          <Snackbar open={notification.open} autoHideDuration={800}>
            <Alert severity={notification.type}>{notification.message}</Alert>
          </Snackbar>
        </form>
      )}
    />
  );

  if (error) return <Error />;

  return ui;
};

const Availability = () => {
  useAuthenticated();
  const uid = localStorage.getItem("user");
  const { loaded, data, error } = useQuery({
    type: "getOne",
    resource: "User",
    payload: { id: uid },
  });

  let ui = null;
  if (!loaded) {
    ui = <Loading />;
  } else {
    ui = <AvailabilityForm aid={data.availability && data.availability.id} />;
  }

  if (error) return <Error />;

  return ui;
};

export default Availability;
